import {object, string} from "yup";

import type {Field, TForm} from "types";

const fields: Field[] = [
	{
		type: "text",
		name: "code",
		label: "Enter code from Authenticator",
		placeholder: "Enter Code",
		// RightIcon: EyeHideIcon,
		// RightToggledIcon: EyeShowIcon,
	},
];

const schema = object().shape({
	code: string().required("Code is a required field"),
	// .min(6, "Must be minimum 6 characters long.")
	// .max(6, "Must be maximum 6 characters long."),
	// newPassword: string()
	//     .required("Password is a required field")
	// .matches(/^[^\s]+$/, "Must not contain whitespace.")
	// .matches(/[A-Z]/, "Must have at least one Uppercase.")
	// .matches(/[a-z]/, "Must have at least one Lowercase.")
	// .matches(/[!@#\$%^&*(),.?":{}|<>]/, "Must have at least one Special Symbol.")
	// .notOneOf(
	// 	[ref("currentPassword"), null],
	// 	"The new password must not match the previous one",
	// ),

	// repeatNewPassword: string()
	// 	.required("This field is required.")
	// 	.oneOf([ref("newPassword"), null], "Passwords do not match."),
});

const codeFromAuthenticatorAppForm: TForm = {
	fields,
	schema,
};

export default codeFromAuthenticatorAppForm;
